import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ProfileEffects } from './profile.effects';
import * as fromProfile from './profile.reducers';

import { SharedModule } from '@shared/shared.module';

import * as fromComponents from './components';
import { ProfileRoutingModule } from './profile-routing.module';
import { ProductSwitchComponent } from '../general/pages/product-switch/product-switch.component';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([ProfileEffects]),
    FormsModule,
    NgxIntlTelInputModule,
    ProfileRoutingModule,
    ReactiveFormsModule,
    StoreModule.forFeature(fromProfile.PROFILE_REDUCER_FEATURE_KEY, fromProfile.reducer),
    SharedModule,
    TranslateModule
  ],
  exports: [fromComponents.ProfilePersonalDetailsComponent, fromComponents.Profile2FAComponent],
  declarations: [...fromComponents.components, ProductSwitchComponent],
  providers: []
})
export class ProfileModule {}
